// extracted by mini-css-extract-plugin
export default {"footer":"SimpleFooter_footer__rEFTk","copyrightText":"SimpleFooter_copyrightText__gizeh","darkMode":"SimpleFooter_darkMode__4b86F"};